<template>
  <form @submit.prevent="onSubmit">
    <TextInput id="doubt-title" required label="Título" v-model:model-value="title"/>
    <TextareaInput id="rating" v-model:model-value="description" label="Descrição" required/>
    <GradientButton title="Enviar dúvida"/>
  </form>
</template>

<script>
import TextInput from "../../components/application/inputs/TextInput";
import TextareaInput from "../../components/application/inputs/TextareaInput";
import GradientButton from "../../components/application/buttons/GradientButton";
import {ref} from "vue";
import {useStore} from "vuex";
import {dispatchError} from "../../utils/error_handling";
import {ContentDoubt} from "./helpers";
import {dispatchSuccessBox} from "../../components/mixins";

export default {
  name: "ContentDoubtsForm",
  components: {GradientButton, TextareaInput, TextInput},
  setup() {
    const store = useStore();

    const title = ref("");
    const description = ref("");

    const onSubmit = async () => {
      try {
        await createDoubt();
        clearAllFields();
        await dispatchSuccessBox("Dúvida cadastrada com sucesso!")
      } catch (e) {
        console.error("[onSubmit] Error createDoubt ", e);
        await dispatchError(e);
      }
    }

    const createDoubt = async () => {
      try {
        await store.dispatch("content_module/doubt/createDoubt", new ContentDoubt(title.value, description.value));
      } catch (e) {
        console.error("[createDoubt] Error dispatch ", e);
        throw e;
      }
    };

    const clearAllFields = () => {
      title.value = "";
      description.value = "";
    };

    return {
      title,
      description,
      onSubmit,
    };
  }
}
</script>

<style scoped>
form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 700px;
  width: 100%;
  min-height: 260px;
}
</style>